import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-create-game-info-modal',
    templateUrl: './create-game-info-modal.component.html',
    styleUrls: ['./create-game-info-modal.component.scss'],
    standalone: false
})
export class CreateGameInfoModalComponent implements OnInit {

  constructor(
    private activeModal:NgbActiveModal
  ) { }

  @Input() map_name: string;

  ngOnInit(): void {

    setTimeout(() => {
      this.activeModal.close('dismissed')
    }, 3000);
  }

}
